import { motion } from 'framer-motion';
import '../styles/ContactMe.scss';
import { socialLinksData } from '../utils/constants';

const list = {
	hidden: { opacity: 0 },
	show: {
		opacity: 1,
		transition: { staggerChildren: 0.08 },
	},
};

const item = {
	hidden: { opacity: 0, y: 8 },
	show: {
		opacity: 1,
		y: 0,
		transition: { type: 'spring', stiffness: 300, damping: 20 },
	},
};

function SocialLinks({ variant }) {
	const socialLinks = socialLinksData(variant);
	return (
		<motion.ul
			className="Footer-icons"
			variants={list}
			initial="hidden"
			whileInView="show"
			viewport={{ once: true, amount: 0.2 }}
		>
			{socialLinks.map((link) => (
				<motion.li key={link.name} variants={item}>
					<motion.a
						href={link.url}
						target="_blank"
						rel="noreferrer"
						style={{ display: 'inline-block', transformOrigin: 'center' }}
						whileHover={{ scale: 1.15 }}
						whileTap={{ scale: 0.95 }}
						transition={{ type: 'spring', stiffness: 400, damping: 24 }}
					>
						<img src={link.icon} alt={link.name} />
					</motion.a>
				</motion.li>
			))}
		</motion.ul>
	);
}

export default SocialLinks;
